const footerInit = () => {
  const footer: HTMLElement = document.querySelector('.footer');
  const columns: any = footer.querySelectorAll('.footer__links-col');

  const handleClick = (column: HTMLElement) => {
    column.classList.toggle('mobile-show');
  };

  columns.forEach((column: HTMLElement) => {
    const title: HTMLElement = column.querySelector('.footer__menu-title');
    title.addEventListener('click', () => handleClick(column));
  });
};

export default footerInit;
